import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/snap',
    name: 'Snap',
    component: () => import(/* webpackChunkName: "snap" */ '../views/Snap.vue')
  },
  {
    path: '/beep',
    name: 'Beep',
    component: () => import(/* webpackChunkName: "beep" */ '../views/Beep.vue')
  },
  {
    path: '/atomic',
    name: 'Lazer',
    component: () => import(/* webpackChunkName: "atomic" */ '../views/Lazer.vue')
  },
  {
    path: '/jack',
    name: 'Jack',
    component: () => import(/* webpackChunkName: "jack" */ '../views/Jack.vue')
  },
  {
    path: '/loons',
    name: 'Loons',
    component: () => import(/* webpackChunkName: "loons" */ '../views/Loons.vue')
  },
  {
    path: '/dloons',
    name: 'Dloons',
    component: () => import(/* webpackChunkName: "dloons" */ '../views/Dloons.vue')
  },
  {
    path: '/bumbleme',
    name: 'Bumble',
    component: () => import(/* webpackChunkName: "bumble" */ '../views/Bumble.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
